module.exports = __webpack_public_path__ + "media/images/icons/caret-down-cecf02d6323b71293d14b324183ee755.svg";